import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, Lock, Eye, Trash2, Cookie, Share2 } from 'lucide-react';

const API_URL = '';

const SECTION_ICONS = [Shield, Eye, Lock, Share2, Trash2, Cookie];

export default function PrivacyPolicyPage() {
  const [policy, setPolicy] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/api/privacy-policy`)
      .then(res => res.json())
      .then(data => setPolicy(data))
      .catch(() => {});
  }, []);

  if (!policy) return <div className="min-h-screen bg-[#FCFBF9] flex items-center justify-center"><div className="loading-spinner" /></div>;

  return (
    <div className="min-h-screen bg-[#FCFBF9]" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <Lock size={40} className="mx-auto mb-4 text-[#D4AF37]" />
          <h1 className="font-serif text-4xl mb-3" data-testid="privacy-title">{policy.title}</h1>
          <p className="text-sm text-[#6B6A68]">Dernière mise à jour : {policy.last_updated}</p>
        </div>

        <div className="space-y-8">
          {policy.sections.map((section, idx) => {
            const Icon = SECTION_ICONS[idx] || Shield;
            return (
              <div key={idx} className="bg-white border border-[#E0DFDD] p-8" data-testid={`privacy-section-${idx}`}>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-[#F4E3E1] rounded-full flex items-center justify-center flex-shrink-0">
                    <Icon size={18} className="text-[#1A1514]" />
                  </div>
                  <div>
                    <h2 className="font-serif text-xl mb-3">{section.title}</h2>
                    <p className="text-sm text-[#6B6A68] leading-relaxed">{section.content}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-[#6B6A68]">
            Pour toute question concernant vos données, contactez-nous sur{' '}
            <a href="https://wa.me/213782367184" className="text-[#D4AF37] hover:underline">WhatsApp</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
